<template>
  <b-modal class="modal-lg" id="reassignModal" ref="reassign-modal" :title="reassignModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo(reassignModal.modalData.entries)" @hide="resetModal('main')">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'exchange-alt']" size="1x" class="mr-2"/> {{ reassignModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="reassignModal.docuData.docsChecked && reassignModal.docuData.docsChecked.length">
        <b-form-select v-model="reassignModal.updateData.new_customer" :options="customerIds" :select-size="4"></b-form-select>
        <!--<div class="mt-3">{{ t('labelSelected', 'labelSelected')}} : <strong>{{t('customerId', 'customerId')}}{{ reassignModal.updateData.new_customer }}</strong></div>-->
      </template>
      <template v-else>
        <h5 class="text-danger">{{t('docEmailModalNoDocsSelected','docEmailModalNoDocsSelected')}}</h5>
        <p class="text-danger">{{t('docEmailModalPleaseSelectDocsFirst','docEmailModalPleaseSelectDocsFirst')}}</p>
      </template>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="reassignModal.docuData.docsChecked.length">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="ReassignCustomer" data-dismiss="modal" class="btn btn-primary" type="button" @click="reassignCustomer()">
          {{ t('reassignDocumentsButtonText', 'reassignDocumentsButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'


export default {
  name: 'ModalReassignDoc',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'searchDocuments'
  ],
  data () {
    return {
    reassignModal: {},
      buttonIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    customerIds: {
      get(){
        return this.$store.getters['documentToolsStore/getCustomerIds']
      }
    }
  },
  methods:{
    fetchAdditionalInfo() {
      //clear previous response
      this.$store.dispatch('alertClearResponse')
      this.buttonIsBusy = false
      this.$store.dispatch('documentToolsStore/getCustomerIds')
    },
    reassignCustomer() {
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool',{
        action: 'assignDocsToAnotherCustomers',
        documents: this.reassignModal.docuData.docsChecked,
        customerId: this.reassignModal.updateData.new_customer
      })
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['reassign-modal'].hide()
          if(responseStatus != 'noChange') {
            this.searchDocuments()
          }
        }
      })
    }
  },
  created() {
    this.reassignModal = this.$attrs.modal
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
</style>
